<template>
  <div style="width: 80%;padding: 20px" v-loading="loading">
<!--    {{path}}-->
    <div style="color: rgba(203,68,68,0.93);padding: 30px">
      <h3 style="text-align: center">该模块错误</h3><br>
      <p style="margin-bottom: 0px">错误信息：</p>
      <div v-html="errMess" style="white-space: pre-line;text-indent: 2em">
      </div></div>
  </div>
</template>

<script>
export default {
  name: "ErrProject",
  created() {
    this.projectId = this.$route.query.projectId
    this.analyzeId = this.$route.query.analyzeId
    this.path = this.$route.query.path
    this.getErr()
  },
  data() {
    return {
      errMess: '',
      analyzeId: '',
      path: '',
      loading:true,
    }
  },
  methods: {
    async getErr() {
      const res = await this.$http.get('/preview/dirFiles/' + this.projectId + "/" + this.analyzeId + "/" + this.path)
      if(res){
        if (res.code === 5856) {
          this.errMess = res.data
          this.loading=false
        }
      }
      },
    },
}
</script>

<style scoped>

</style>
